const REQUEST_VERIFICATION_TOKEN_HEADER_NAME = "X-RequestVerificationToken";

export function getToken(): string | undefined {
	const element: HTMLInputElement | null = document.querySelector<HTMLInputElement>(
		"input[name=__RequestVerificationToken]"
	);

	return element?.value;
}

export function getHeaderName(): string {
	return REQUEST_VERIFICATION_TOKEN_HEADER_NAME;
}
